import { SET_LOADED, SET_SIDEBAR_OPEN, SET_THEME_MODE } from './types';

export const initialState = {
  loaded: false,
  isSidebarOpened: false,
  themeMode: 'light',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_LOADED:
      return {
        ...state,
        loaded: true,
      };
    case SET_SIDEBAR_OPEN:
      return {
        ...state,
        isSidebarOpened: action.payload,
      };
    case SET_THEME_MODE:
      return {
        ...state,
        themeMode: action.payload,
      };
    default:
      return state;
  }
};
